export const useShortcutsOnRouteFocused=(_shortcutKey,_onShortcuts)=>{};